import { useEffect, useState, useRef } from 'react';
import Nav from './Components/Nav';
import Footer from './Components/Footer';
import Image from './Components/Image';
import Header_Text from './Components/Header-text';
import './css/app.css';
import Home from './Pages/Home';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import Contact from './Pages/Contact';
import headshot1 from './Assets/Gaby_Headshot.jpg';
import headshot2 from './Assets/Gaby_Headshot2.jpg';


function App() {
  
  const homeRef = useRef(null);
  const contactRef = useRef(null);
  const reelRef = useRef(null);
  const filmMakingRef = useRef(null);
  const intimacyRef = useRef(null);
  
  const [dataFromHome, setDataFromHome] = useState("About Gaby");
  var index = 0;
  console.log(dataFromHome);

  const headline_text = "About Gaby";
  var bartext;
  const outerScrollRef = useRef();

  function handleScroll(){

  }
  function handleScrollEnd(){

  }

  const handleclick =  () =>{
    const element = document.getElementById("land");
    const style = element.style;
    style.width = "0%";
    console.log("clicked");
  }


   
  return (
    // <Router> 
    //   <Nav></Nav>

    
    //     <Switch>
    //       <Route path="/page2">
    //         <div>
    //           HELLO
    //         </div>
    //       </Route>
    //       <Route path="/Contact">
    //         <Contact/>
    //       </Route>
    //       <Route path="/">
    //         <Home></Home>
    //       </Route>
          

    //     </Switch>
    //   <Footer></Footer>
    // </Router>
    <>
      <img id="land" src={headshot1} style={{position:"absolute", zIndex:"50",width: "100%", height: "100%"}} onClick={handleclick}></img>
      <Nav 
        headline={dataFromHome} 
        homeRef={homeRef} 
        reelRef={reelRef} 
        filmMakingRef={filmMakingRef}
        contactRef={contactRef}
        intimacyRef={intimacyRef}
        sendDataToApp={setDataFromHome}>
      </Nav>
      <article 
        className='scroll-wrapper' 
        ref={outerScrollRef} 
        onScroll={handleScroll} 
        onScrollEnd={handleScrollEnd}>
        <div 
          className='scroll-section' 
          ref={homeRef}>
          <Home headshot={headshot1} id="l" outerScrollRef={outerScrollRef} sendDataToApp={setDataFromHome}></Home>
        </div>
        <div className='scroll-section' ref={filmMakingRef} id="movie">
          
          <iframe width="504" height="285" src="https://www.youtube.com/embed/cHHbXB5dbAY?si=t8pUAPYRL0ITRxd9" frameBorder={0} id="Compassion"></iframe>
          <iframe width="504" height="285" src="https://www.youtube.com/embed/cHHbXB5dbAY?si=t8pUAPYRL0ITRxd9" frameBorder={0} id="If_I_Knew"></iframe>

        </div>
        <div className='scroll-section' ref={intimacyRef}>Section 3</div>
        <div className='scroll-section' ref={reelRef}>Section 4</div>
        <div className='scroll-section' ref={contactRef}>
          <Contact></Contact>
        </div>

        {/* <div className='scroll-section'>
        <Image link={headshot1} className="Headshot"></Image>
        </div>
        <Home></Home>
        <Contact></Contact>
        <Footer></Footer> */}
      </article>
    </>

  );
}

export default App;
